// Copies the anchor link URL to the clipboard when clicked.
// Usage:
//   <a href="#section-id"
//      data-controller="anchor-link"
//      data-action="click->anchor-link#copy">
//     #
//   </a>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy(event) {
    event.preventDefault()

    const anchor = this.element.getAttribute("href")
    const url = `${window.location.origin}${window.location.pathname}${anchor}`

    navigator.clipboard.writeText(url).then(() => {
      Stoked.toast("Link copied!")
      history.replaceState(null, "", anchor)
    })
  }
}
